import React from 'react';
import clsx from 'clsx';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

import { Icon, useSettings } from 'app/main/components';
import { DetailsSectionWrapper } from 'app/main/components/page-layouts';

export interface DetailsSectionStatsTableColumnType {
	header: string;
	valueFormatter: (stat: any) => React.ReactNode;
	// align?: 'right' | 'center' | 'left' | 'inherit' | 'justify';
}

interface DetailsSectionStatsTableRowProps {
	typeColumn: DetailsSectionStatsTableColumnType;
	columns: DetailsSectionStatsTableColumnType[];
	stat: any;
}

interface DetailsSectionStatsTableProps {
	title: string;
	typeColumn: DetailsSectionStatsTableColumnType;
	columns: DetailsSectionStatsTableColumnType[];
	stats: any[];
}

function DetailsSectionStatsTableRow(props: DetailsSectionStatsTableRowProps) {
	const { t } = useSettings();

	const typeName = props.typeColumn.valueFormatter(props.stat);
	const isTotal = typeName === 'TOTAL';
	const isNoType = typeName === 'NO_TYPE';

	return (
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0, fontWeight: 500 } }}>
			<TableCell className={clsx('min-w-128 px-8', isNoType ? 'italic' : undefined)} component="th" scope="row">
				{isTotal
					? t('PROJ_SECTION_WORKREPORTS_STATS_TOTAL')
					: isNoType
						? t('PROJ_SECTION_WORKREPORTS_STATS_NO_TYPE')
						: typeName}
			</TableCell>
			{props.columns.map((column, index) => (
				<TableCell key={index} className="min-w-128 px-8 tabular-nums" align="right">
					{column.valueFormatter(props.stat)}
				</TableCell>
			))}
		</TableRow>
	);
}

export default function DetailsSectionStatsTable(props: DetailsSectionStatsTableProps) {
	return (
		<DetailsSectionWrapper avatar={<Icon icon="chart-bar" />} title={props.title} disablePadding>
			<TableContainer>
				<Table size="small">
					<TableHead>
						<TableRow>
							<TableCell className="min-w-128 px-8">{props.typeColumn.header}</TableCell>
							{props.columns.map((stat, index) => (
								<TableCell key={index} className="min-w-128 px-8" align="right">
									{stat.header}
								</TableCell>
							))}
						</TableRow>
					</TableHead>
					<TableBody>
						{props.stats.map((stat, index) => (
							<DetailsSectionStatsTableRow
								key={index}
								typeColumn={props.typeColumn}
								columns={props.columns}
								stat={stat}
							/>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</DetailsSectionWrapper>
	);
}
